const prefix = 'ACCOUNT_SETTINGS/';
export const SET = prefix + 'SET';
export const RESET = prefix + 'RESET';
export const TEAM_LOAD_TEAM_START = prefix + 'TEAM_LOAD_TEAM_START';
export const TEAM_LOAD_TEAM_SUCCESS = prefix + 'TEAM_LOAD_TEAM_SUCCESS';
export const TEAM_LOAD_TEAM_ERROR = prefix + 'TEAM_LOAD_TEAM_ERROR';
